import React from "react";
import { GoDotFill } from "react-icons/go";
import styles from "./styles.module.css";

const PHRASE = "WEAR LORMAMI — TRENDS OF THE FUTURE";

const Marquee = () => {
  const items = Array.from({ length: 6 });
  return (
    <div className={styles.marqueeH}>
      <div className={styles.track}>
        {[0, 1].map((dup) => (
          <div className={styles.group} key={dup} aria-hidden={dup === 1}>
            {items.map((_, i) => (
              <span className={styles.item} key={i}>
                {PHRASE}
                <GoDotFill className={styles.marqueeI} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
